import { render, staticRenderFns } from "./UpdateSuccessModal.vue?vue&type=template&id=0f96adf5&scoped=true&"
import script from "./UpdateSuccessModal.vue?vue&type=script&lang=js&"
export * from "./UpdateSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSuccessModal.vue?vue&type=style&index=0&id=0f96adf5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96adf5",
  null
  
)

export default component.exports